module.exports = __webpack_public_path__ + "static/media/bring-front.467515be.svg";